import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { IMenuItem } from 'src/app/models/interfaces/IMenuItem';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  styleUrls: ['./user-dropdown.component.scss'],
})
export class UserDropdownComponent implements OnInit {

  @Input() dismissPopover = () => { }; // Delegate

  settingLinks: IMenuItem[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.settingLinks = [
      { label: 'Options.Label', icon: 'settings', path: ['/options'] },
      { label: 'Messages_Account', icon: 'person', path: ['/account/manage'] },
      { label: 'Messages_Formulas', icon: 'calculator', path: ['/formulas'] },
      { label: 'Messages_Help', icon: 'help', path: ['/help'] },
      // { label: 'Messages_Admin', icon: 'cloud', path: ['/admin'] }
    ];
  }

  logout() {
    this.dismissPopover();
    return this.authService.logout().then(() =>
      this.router.navigate(['/login'])
    );
  }

}
